module.exports = __webpack_public_path__ + "img/home_core_icon_02.13095261.png";